import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { inject, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthTokenService } from '@shared/services/auth-token.service';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);
  const tokenService = inject(AuthTokenService);
  const token = tokenService.getToken();
  const headers: any = {
    'Accept': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Token ${token}`;
  }

  let url = req.url;
  if (environment.apiUrl && !url.startsWith('http')) {
    url = `${environment.apiUrl}${url}`;
  }

  const apiReq = req.clone({
    url: url,
    setHeaders: headers,
  });

  return next(apiReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        const requestHadToken = apiReq.headers.has('Authorization');
        if (requestHadToken) {
          const hadToken = !!tokenService.getToken();
          tokenService.clearToken();
          if (hadToken) {
            setTimeout(() => {
              try {
                const router = injector.get(Router);
                if (!router.url.includes('/auth/login')) {
                  router.navigate(['/auth/login']);
                }
              } catch {}
            }, 0);
          }
        }
      }
      if (error.status === 500) {
        setTimeout(() => {
          try {
            const router = injector.get(Router);
            const from = router.url;
            if (!from.includes('/server-error')) {
              router.navigate(['/server-error'], { queryParams: { from } });
            }
          } catch {}
        }, 0);
      }
      return throwError(() => error);
    })
  );
};
